'use client'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { useLang } from '@/context/LangContext'
import wordmark from '@/logos/lexoya-wordmark.svg'

interface LogoLinkProps {
  className?: string
}

export default function LogoLink({ className = '' }: LogoLinkProps) {
  const lang = useLang()
  const pathname = usePathname()
  const homePath = `/${lang}`
  const isHome = pathname === homePath || pathname === `${homePath}/`

  if (isHome) {
    return (
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`cursor-pointer bg-transparent border-0 p-0 ${className}`}
        aria-label="Lexoya"
      >
        <img src={wordmark.src} alt="Lexoya" className="h-6 w-auto" />
      </button>
    )
  }

  return (
    <Link href={homePath} className={className} aria-label="Lexoya">
      <img src={wordmark.src} alt="Lexoya" className="h-6 w-auto" />
    </Link>
  )
}
